<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="sa_name"
      placeholder="输入活动名称关键字查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/crm/activity/' + item.id"
      >
        <div class="weui-cell__bd">
          <p>{{ item.sa_name }}</p>
          <p class="list-item-muted">{{ item.sa_begintime }}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{ item.sa_code }}</p>
          <span
            class="list-item-status"
            :class="{ warning: item.sa_status != 'AUDITED' }"
            >{{ item.sa_status }}</span
          >
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{ items.length }}次</label>
    </div>
    <add-button to="/crm/activity_edit"/>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/crm/activity/list",
      filters: [
        {
          type: "date",
          name: "sa_begintime",
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "待审核",
              condition: "sa_statuscode!='AUDITED'",
            },
            {
              value: 2,
              label: "已审核",
              condition: "sa_statuscode='AUDITED'",
            },
          ],
        },
      ],
    };
  },
};
</script>